import { render, staticRenderFns } from "./Adminitration_RawMaterialTypes.vue?vue&type=template&id=675e4498"
import script from "./Adminitration_RawMaterialTypes.vue?vue&type=script&lang=js"
export * from "./Adminitration_RawMaterialTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports